<template>
  <div>
    <div v-if="EditView" class="container">
      <div class="page-inner">
        <div class="page-header gp-admin-page-heading">
          <h3 class="fw-bold">{{ form.stpId ? 'Alterar SMTP' : 'Novo SMTP' }}</h3>
          <ul class="breadcrumbs">
            <li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li>
            <li class="separator"><i class="fa fa-chevron-right"></i></li>
            <li class="nav-item"><a href="#" @click.prevent="cancelar">Cadastro de SMTPs</a></li>
            <li class="separator"><i class="fa fa-chevron-right"></i></li>
            <li class="nav-item"><span>{{ form.stpId ? 'Alterar' : 'Novo cadastro' }}</span></li>
          </ul>
        </div>
        <form class="row" @submit.prevent="salvar">
          <div class="col-md-12">
            <div class="card">
              <div class="gp-admin-form-header">
                <span><v-icon size="20">mdi-email-outline</v-icon></span>
                <div><h4>{{ form.stpId ? 'Alterar SMTP' : 'Novo SMTP' }}</h4><p>Configure o envio de e-mails e os links de acesso por garantidora.</p></div>
              </div>
              <div class="card-body">
                <p class="text-muted">Sem garantidora selecionada, o cadastro será o padrão da GarantePay. Cada garantidora pode ter um único cadastro.</p>
        <div class="row">
          <div class="col-md-6 col-lg-6"><div class="form-group"><label for="smtp-garantidora">Garantidora</label>
            <v-autocomplete id="smtp-garantidora" v-model="garantidoraSelecionada" :items="opcoesGarantidoras"
              item-title="garNomeEmpresa" item-value="garId" density="compact" variant="outlined"
              placeholder="Digite para pesquisar" clearable hide-details
              no-data-text="Nenhuma garantidora encontrada" :disabled="busy" /></div></div>
          <div class="col-md-4 col-lg-4"><div class="form-group"><label for="smtp-host">Servidor SMTP</label><input id="smtp-host" v-model.trim="form.stpSmtp" required maxlength="100" class="form-control" placeholder="smtp.exemplo.com" /></div></div>
          <div class="col-md-2 col-lg-2"><div class="form-group"><label for="smtp-port">Porta</label><input id="smtp-port" v-model.number="form.stpPorta" type="number" required min="1" max="65535" class="form-control" /></div></div>
          <div class="col-md-6 col-lg-6"><div class="form-group"><label for="smtp-email">E-mail de envio (login SMTP)</label><input id="smtp-email" v-model.trim="form.stpEmail" type="email" required maxlength="100" class="form-control" autocomplete="off" /></div></div>
          <div class="col-md-6 col-lg-6"><div class="form-group"><label for="smtp-password">Senha</label><input id="smtp-password" v-model="form.stpSenha" type="password" :required="!form.stpId" class="form-control" autocomplete="new-password" /><small v-if="form.stpId" class="text-muted">Deixe em branco para manter a senha cadastrada.</small></div></div>
          <div class="col-md-6 col-lg-6"><div class="form-group"><label for="smtp-sender">E-mail de remetente</label><input id="smtp-sender" v-model.trim="form.stpEmailRemetente" type="email" maxlength="254" class="form-control" /><small class="text-muted">Usado no remetente e nas respostas. Vazio mantém os padrões atuais.</small></div></div>
          <div class="col-md-6 col-lg-6"><div class="form-group"><label for="smtp-url">URL de visualização</label><input id="smtp-url" v-model.trim="form.stpUrlVisualizacao" type="url" maxlength="2048" class="form-control" placeholder="https://sistema.exemplo.com/" /><small class="text-muted">Endereço base do sistema, sem parâmetros. Vazio mantém o endereço padrão.</small></div></div>
        </div>
              </div>
            </div>
          </div>
          <div class="card-action gp-admin-actions gp-detail-actions">
            <button type="submit" class="btn btn-success" style="color: #ffffff;" :disabled="busy || !loaded">{{ busy ? 'Salvando...' : (form.stpId ? 'Alterar' : 'Salvar') }}</button>
            <button type="button" class="btn btn-link" :disabled="busy" @click="cancelar">Cancelar</button>
          </div>
        </form>
      </div>
    </div>
    <div v-else class="container">
      <div class="page-inner">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <div class="d-flex align-items-center">
                  <h4 class="card-title">Cadastro de SMTPs</h4>
                  <button type="button" class="btn btn-sm btn-secondary ms-auto" :disabled="busy || !loaded" @click="novo"><i class="fa fa-plus"></i> Incluir Novo</button>
                </div>
              </div>
              <div class="card-body">
                <adm-data-table v-model="itemsSelected" :headers="headers" :items="linhasGrid" :loading="!loaded" alternating
                  theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                  body-text-direction="center" rows-per-page-message="Linhas por pagina" file-name="cadastro-smtps">
                  <template #item-stpEmailRemetente="item"><span>{{ item.stpEmailRemetente || 'Padrão' }}</span></template>
                  <template #item-stpUrlVisualizacao="item"><span class="smtp-url">{{ item.stpUrlVisualizacao || 'Padrão' }}</span></template>
                  <template #item-actions="item">
                    <div class="gp-table-actions">
                      <button type="button" class="gp-table-action gp-action-edit" title="Editar" aria-label="Editar SMTP" :disabled="busy" @click="editar(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
                      <button type="button" class="gp-table-action gp-action-delete" title="Excluir" aria-label="Excluir SMTP" :disabled="busy" @click="excluir(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
                    </div>
                  </template>
                </adm-data-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
const vazio = () => ({ stpId: 0, garId: null, stpSmtp: '', stpEmail: '', stpSenha: '', stpPorta: 587, stpEmailRemetente: '', stpUrlVisualizacao: '' })
export default {
  name: 'ControleSmtpView',
  data: () => ({
    EditView: false,
    form: vazio(),
    rows: [],
    garantidoras: [],
    busy: false,
    loaded: false,
    itemsSelected: [],
    headers: [
      { text: 'Id', value: 'stpId', sortable: true },
      { text: 'Garantidora', value: 'garNomeEmpresa', sortable: true },
      { text: 'Servidor SMTP', value: 'stpSmtp', sortable: true },
      { text: 'Porta', value: 'stpPorta', sortable: true },
      { text: 'E-mail de envio', value: 'stpEmail', sortable: true },
      { text: 'Remetente', value: 'stpEmailRemetente', sortable: true },
      { text: 'URL de visualização', value: 'stpUrlVisualizacao', sortable: true },
      { text: 'Ações', value: 'actions' }
    ]
  }),
  computed: {
    opcoesGarantidoras () { return [{ garId: 0, garNomeEmpresa: 'GarantePay (padrão)' }, ...this.garantidoras] },
    garantidoraSelecionada: {
      get () { return this.form.garId || 0 },
      set (value) { this.form.garId = value || null }
    },
    linhasGrid () { return this.rows.map(row => ({ ...row, garNomeEmpresa: this.nomeGarantidora(row.garId) })) }
  },
  mounted () { this.carregar() },
  methods: {
    nomeGarantidora (id) { return id ? this.garantidoras.find(x => x.garId === id)?.garNomeEmpresa || `Garantidora ${id}` : 'GarantePay (padrão)' },
    limpar () { this.form = vazio() },
    novo () { this.limpar(); this.EditView = true },
    cancelar () { if (this.busy) return; this.limpar(); this.EditView = false },
    editar (row) {
      const original = this.rows.find(x => x.stpId === row.stpId)
      if (!original) return
      this.form = { ...original, stpSenha: '' }
      this.EditView = true
    },
    erro (error) { this.$mensagemErro(error.response?.data?.message || 'Não foi possível concluir a operação de SMTP.') },
    async carregar () {
      try {
        const [configs, garantidoras] = await Promise.all([axios.get('/Telas/ControleSmtp/GetAll'), axios.get('/Telas/ControleSmtp/Garantidoras')])
        this.rows = configs.data || []
        this.garantidoras = (garantidoras.data || []).sort((a, b) => (a.garNomeEmpresa || '').localeCompare(b.garNomeEmpresa || '', 'pt-BR'))
        this.loaded = true
      } catch (error) { this.erro(error) }
    },
    async salvar () {
      if (this.busy) return
      if (this.rows.some(x => (x.garId || null) === (this.form.garId || null) && x.stpId !== this.form.stpId)) {
        this.$mensagemAviso('Já existe um SMTP para esta garantidora ou para o cadastro padrão. Edite a linha existente.')
        return
      }
      this.busy = true
      try {
        if (this.form.stpId) await axios.put('/Telas/ControleSmtp/Update', this.form)
        else await axios.post('/Telas/ControleSmtp/Add', this.form)
        this.limpar()
        await this.carregar()
        this.EditView = false
        this.$mensagemAvisoSucesso('Cadastro SMTP salvo.')
      } catch (error) { this.erro(error) } finally { this.busy = false }
    },
    async excluir (row) {
      if (this.busy) return
      const result = await this.$mensagemConfirma(`Excluir o SMTP de ${this.nomeGarantidora(row.garId)}? ${row.garId ? 'Os próximos envios utilizarão o SMTP padrão.' : 'Os envios sem SMTP próprio ficarão sem configuração.'}`)
      if (!result.isConfirmed) return
      this.busy = true
      try {
        await axios.delete(`/Telas/ControleSmtp/Delete/${row.stpId}`)
        if (this.form.stpId === row.stpId) this.limpar()
        await this.carregar()
        this.itemsSelected = []
        this.$mensagemAvisoSucesso('Registro excluído.')
      } catch (error) { this.erro(error) } finally { this.busy = false }
    }
  }
}
</script>
<style scoped>
.smtp-url { max-width: 260px; overflow-wrap: anywhere; }
</style>
